import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { AccountingResult, Bill } from '@jms/model';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { billAccountingListCell, billAccountingResult, BillAccountingListCell } from './bill.accounting.cell';
import { billAccountingBridgeStyles, billAccountingStyleId } from './bill.accounting.theme';

@Component({
  selector: 'bill-accounting-cell-renderer',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: flex; align-items: center; min-width: 0; height: 100%; overflow: hidden;' },
  styles: [`
    bill-accounting-cell-renderer img { display: block; height: 28px; width: auto; max-width: 100%; }
    bill-accounting-cell-renderer .empty { overflow: hidden; color: var(--local-bill-accounting-empty-text); font-style: italic; text-overflow: ellipsis; white-space: nowrap; }
  `],
  template: `
    @if ($cell(); as cell) {
      @if (cell.kind === 'logo' && cell.logo) {
        <img [src]="cell.logo" [alt]="cell.label" [title]="cell.label" />
      } @else {
        <span class="empty" [title]="cell.label">{{ cell.label }}</span>
      }
    }
  `,
})
export class BillAccountingCellRendererComponent implements ICellRendererAngularComp {

  protected readonly $cell = signal<BillAccountingListCell | null>(null);

  private readonly document = inject(DOCUMENT);

  public constructor() {

    DesignSystem.Mount(this.document, billAccountingStyleId, billAccountingBridgeStyles);
  }

  public agInit(params: ICellRendererParams<Bill, AccountingResult>): void {

    this.read(params);
  }

  public refresh(params: ICellRendererParams<Bill, AccountingResult>): boolean {

    this.read(params);
    return true;
  }

  private read(params: ICellRendererParams<Bill, AccountingResult>): void {

    this.$cell.set(billAccountingListCell(billAccountingResult(params.value) ?? params.data?.integration));
  }
}
